import React from 'react'
import styled from 'styled-components'
import IconPreloader from 'loankeeper-common/components/IconPreloader'

import { DocumentTitle, withConstantPermissions } from 'shared'

import InfoTabs from '../Tabs'
import Info from '../Info'
import container from './container'

import DetailsErrorModal from './DetailsErrorModal'
import WindowMarkup from './WindowMarkup'
import ModalMarkup from './ModalMarkup'

const ScrollableContent = styled.div`
  overflow-y: auto;
  position: relative;
  height: ${(props) => props.height}px;

  @media (max-height: 768px) {
    height: ${(props) => (props.height !== 'auto' ? '475px' : 'auto')};
  }
`

const FakeCheckerComponent = ({ children }) => children

@container
@withConstantPermissions(['VIEW_APPLICATION_DMLOG as CanViewDMLOG', 'VIEW_RL as CanViewRL'])
class Details extends React.Component {
  static defaultProps = {
    styleOptions: {
      scrolable: true,
    },
    CheckerComponent: FakeCheckerComponent,
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.loading !== this.props.loading ||
      nextProps.data !== this.props.data ||
      nextProps.location.search !== this.props.location.search ||
      nextProps.error !== this.props.error
    )
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error && this.props.error) {
      this.props.openErrorModal(this.props.error.Text)
    }
  }

  getBaseContextProps = () => {
    const { data, ID, hash, icon, Header, Footer, openContext, tabs, size } = this.props

    const result = {
      icon,
      onClose: this.unregister,
      Header,
      Footer,
      openContext,
      data,
      ID,
      hash,
      tabs,
      size,
    }

    if ((data.ProductType !== 5 || data.ProductType !== '5') && tabs) {
      delete result.tabs.bic
    }

    return result
  }

  getModalContextProps = () => {
    const { getWindowName, data, ID, name } = this.props

    const commonProps = this.getBaseContextProps()

    return {
      ...commonProps,
      name,
      heading: getWindowName(data, ID),
      isModal: true,
    }
  }

  getWindowContextProps = () => {
    const { identifier, getWindowName, getUri, data, ID, hash, operationID, operationHash } = this.props

    const commonProps = this.getBaseContextProps()

    return {
      ...commonProps,
      identifier,
      name: getWindowName(data, ID),
      uri: getUri(data, ID, hash, operationID, operationHash),
      search: this.props.location.search,
      isModal: false,
    }
  }

  unregister = () => {
    this.props.destroyGrids()
    this.props.unregister(this.props.type, this.props.ID)
  }

  render() {
    const {
      type,

      ID,
      hash,
      operationID,
      operationHash,

      tabs,
      getWindowName,

      noSlider,

      CheckerComponent,

      loading,
      data,

      clearErrors: onCloseErrorModal,

      iconCollection,
      openContext,
      defaultTabIndex,
    } = this.props

    if (loading || !data) {
      return null
    }

    if ((data.ProductType !== 7 || data.ProductType !== '7') && tabs) {
      delete tabs.bic
    }

    const isModal = openContext === 'modal'

    const ComponentToWrappIn = isModal ? ModalMarkup : WindowMarkup

    const wrapperProps = isModal ? this.getModalContextProps() : this.getWindowContextProps()

    return (
      <>
        <DocumentTitle title={getWindowName(data, ID)} />
        <DetailsErrorModal name="DetailsErrorModal" onClose={onCloseErrorModal} />
        {isModal ? (
          <ComponentToWrappIn {...wrapperProps}>
            {!noSlider && (
              <InfoTabs
                type={type}
                ID={ID}
                hash={hash}
                operationID={operationID}
                operationHash={operationHash}
                tabs={tabs(data)}
                defaultTabIndex={defaultTabIndex}
                openInModal
              />
            )}

            <ScrollableContent className="u-fluid u-flex u-directionColumn" height={515}>
              <Info type={type} ID={ID} hash={hash} tabs={tabs(data)} openInModal />
            </ScrollableContent>
          </ComponentToWrappIn>
        ) : (
          <CheckerComponent ID={ID} hash={hash} data={data}>
            <ComponentToWrappIn {...wrapperProps}>
              {!noSlider && (
                <InfoTabs
                  type={type}
                  ID={ID}
                  hash={hash}
                  operationID={operationID}
                  operationHash={operationHash}
                  tabs={tabs(this.props)}
                  defaultTabIndex={defaultTabIndex}
                  openInModal={false}
                />
              )}

              <ScrollableContent
                className="u-fluid u-flex u-directionColumn details-content primary-font"
                height="auto"
              >
                <Info type={type} ID={ID} hash={hash} tabs={tabs(this.props)} openInModal={false} />
              </ScrollableContent>
            </ComponentToWrappIn>
          </CheckerComponent>
        )}

        {iconCollection && <IconPreloader collection={iconCollection} />}
      </>
    )
  }
}

export default Details
